import { ButtonV2, StaffCard } from 'components';
import React, { useEffect, useMemo, useRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import './style.scss';

function StaffSelectionList({
  allStaff = [],
  assignedStaff = [],
  initialAssignedStaff = [],
  roles = [],
  onChange,
  hideSelect,
  hideDelete,
  currentUser,
  isDefaultRole = false
}) {
  const assignedIds = useMemo(() => assignedStaff.map(id => id.replace(/^PCO:STAFF:/, '')), [assignedStaff]);
  const initialAssignedIds = useRef(initialAssignedStaff.map(id => id.replace(/^PCO:STAFF:/, ''))).current;

  const selectedStaff = useMemo(() => allStaff.filter(staff => assignedIds.includes(staff.id)), [
    allStaff,
    assignedIds
  ]);

  const roleByStaffId = useMemo(() => {
    const map = {};
    (roles || []).forEach(role => {
      (role.pom_staff_identifiers || [])
        .map(full => full.replace(/^PCO:STAFF:/, ''))
        .forEach(id => {
          if (!map[id]) map[id] = role.name;
        });
    });
    return map;
  }, [roles]);

  const isSelf = id => currentUser?.teacher?.id && currentUser.teacher.id === id;

  useEffect(() => {
    req.staff();
  }, []);

  const handleDelete = staffId => {
    if (isSelf(staffId)) return;
    if (typeof onChange !== 'function') return;

    const updated = assignedStaff.filter(fullId => {
      const id = fullId.replace(/^PCO:STAFF:/, '');
      return id !== staffId;
    });
    onChange(updated);
  };

  const openStaffSelectionModal = () => {
    const handleSubmit = ids => {
      const updated = ids.map(id => `PCO:STAFF:${id}`);
      onChange?.(updated);
    };

    const mapPersonIdToDisabledTooltip = {
      [currentUser?.teacher?.id ?? '']: 'You cannot change your own role.'
    };

    if (isDefaultRole) {
      initialAssignedIds.forEach(
        id =>
          (mapPersonIdToDisabledTooltip[id] =
            'System Non-Admin is a locked, default role automatically assigned to staff removed from a custom role. While permissions can be edited, this role cannot be deleted.')
      );
    }

    Actions.showModal('SelectAssociatedStaff', {
      selected: selectedStaff.map(s => s.id),
      staff: allStaff,
      onSubmit: handleSubmit,
      mapPersonIdToDisabledTooltip
    });
  };

  return (
    <div className="edit-select-staff-list">
      <div className="edit-select-staff-list__title">
        <div>
          <span>{selectedStaff.length}</span> selected
        </div>

        {selectedStaff.length > 0 && !hideSelect && (
          <div className="edit-select-staff-list__link" onClick={openStaffSelectionModal}>
            Select Staff
          </div>
        )}
      </div>

      {selectedStaff.length > 0 ? (
        <div className="edit-select-staff-list__content">
          <Scrollbars autoHeight autoHeightMin={0} autoHeightMax={1000}>
            {selectedStaff.map(s => {
              const self = isSelf(s.id);
              const roleName = roleByStaffId[s.id];
              return (
                <StaffCard
                  key={`staff-${s.id}`}
                  checkable={false}
                  staff={s}
                  roleName={roleName}
                  actionIcon={!hideDelete && !self ? 'delete' : undefined}
                  action={!self ? () => handleDelete(s.id) : undefined}
                  actionDisabledTooltip={
                    isDefaultRole && initialAssignedIds.includes(s.id)
                      ? 'System Non-Admin is a locked, default role automatically assigned to staff removed from a custom role. While permissions can be edited, this role cannot be deleted.'
                      : undefined
                  }
                />
              );
            })}
          </Scrollbars>
        </div>
      ) : (
        <div className="edit-select-staff-list__button">
          <ButtonV2
            secondary
            label="Select Staff"
            type="button"
            onClick={openStaffSelectionModal}
            data-cy="select-staff"
          />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  currentUser: state.currentUser.data,
  allStaff: state.staff.data,
  roles: state.roles.data.permission_roles
});

export default connect(mapStateToProps)(StaffSelectionList);
